const ENABLED_KEY = "mbs_akil_widget_enabled";
const AUTO_OPEN_KEY = "mbs_akil_widget_auto_open";
const PREF_EVENT = "akil-widget-pref-changed";
const OPEN_EVENT = "akil-widget-open";
const CLOSE_EVENT = "akil-widget-close";

export function isAkilWidgetEnabled() {
    try {
        return localStorage.getItem(ENABLED_KEY) !== "0";
    } catch {
        return true;
    }
}

export function setAkilWidgetEnabled(enabled) {
    try {
        localStorage.setItem(ENABLED_KEY, enabled ? "1" : "0");
    } catch {
        /* ignore */
    }
    window.dispatchEvent(new CustomEvent(PREF_EVENT, { detail: { enabled } }));
}

export function isAkilWidgetAutoOpen() {
    try {
        return localStorage.getItem(AUTO_OPEN_KEY) === "1";
    } catch {
        return false;
    }
}

export function setAkilWidgetAutoOpen(autoOpen) {
    try {
        localStorage.setItem(AUTO_OPEN_KEY, autoOpen ? "1" : "0");
    } catch {
        /* ignore */
    }
    window.dispatchEvent(new CustomEvent(PREF_EVENT, { detail: { autoOpen } }));
}

export function openAkilWidget() {
    window.dispatchEvent(new CustomEvent(OPEN_EVENT));
}

export function closeAkilWidget() {
    window.dispatchEvent(new CustomEvent(CLOSE_EVENT));
}

export const AKIL_WIDGET_PREF_EVENT = PREF_EVENT;
export const AKIL_WIDGET_OPEN_EVENT = OPEN_EVENT;
export const AKIL_WIDGET_CLOSE_EVENT = CLOSE_EVENT;
